export default `:host(ids-tab-content[active]) {
  display: block;
  color: var(--ids-tab-content-color-text);
  width: 100%;
}

:host(ids-tab-content:not([active])) {
  display: none;
}

:host([disabled]) {
  user-select: none;
  pointer-events: none;
}
:host([disabled]) .ids-tab-content-wrapper {
  opacity: var(--ids-opacity-disabled);
}

/* Lazy loading styles */
.ids-tab-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.ids-tab-content-loading {
  display: none;
  align-items: center;
  justify-content: center;
  padding: var(--ids-space-lg);
  min-height: 200px;
}

.ids-tab-content-error {
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: var(--ids-space-none);
  min-height: 120px;
  text-align: center;
}

.ids-tab-content-main {
  width: 100%;
  height: 100%;
}

/* Loading state */
:host([loading]) .ids-tab-content-loading {
  display: flex;
}

:host([loading]) .ids-tab-content-main {
  display: none;
}

/* Error state */
:host([error]) .ids-tab-content-error {
  display: flex;
}

:host([error]) .ids-tab-content-main {
  display: none;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  flex: 1;
  min-block-size: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
